// Utils.
import { isNumber, toNumber } from '../../../utils';

const sanitize = (type, val) => {
  // Empty...
  if (typeof val === 'undefined') {
    return undefined;
  }

  // Handle what should be a Number.
  if (type === 'number') {
    // Is Number-like.
    if (isNumber(val)) {
      // Convert to Number primitive.
      return typeof val === 'string' ? toNumber(val) : val;
    }
    // Enforce a Number.
    return 0;
  }

  // Trim whitespace.
  const str = val.trim();
  // Is String.
  return str;
};

export default sanitize;



// WEBPACK FOOTER //
// ./src/components/Form/Field/sanitize.js